import { TbBrandGithub } from 'react-icons/tb'
import { Heading } from 'ui-kit/typography'
import { Link } from 'ui-kit/actions/link/Link'
import { BreadcrumbsNavigation, isBreadcrumb } from 'routes/components/Shared'
import { LINKS } from 'routes/constants'
import { TitleBlockScenarioTemplate } from 'routes/Scenarios/helpers/types'
import clsx from 'clsx'
import classes from './ScenarioTitleBlock.module.scss'

export const ScenarioTitleBlock = ({
  data,
}: {
  data: TitleBlockScenarioTemplate
}) => {
  const { addScenario, name, demoAppUri, demoGithubRepo } = data

  const viewExampleScenario = demoAppUri
  const exploreExampleScenario = `https://github.com/${demoGithubRepo}`

  const breadcrumbs = [
    {
      href: LINKS.SCENARIOS,
      name: 'Scenarios',
    },
    { name: name },
  ].filter(isBreadcrumb)

  return (
    <>
      <BreadcrumbsNavigation
        breadcrumbs={breadcrumbs}
        className={classes.breadcrumbs}
      />
      <hgroup className={classes.heading}>
        <Heading as={'h1'} size={'xl'} balance>
          {name}
        </Heading>

        <div className={classes.actions}>
          {demoAppUri && (
            <Link
              className={classes.button}
              asPageButton
              type='secondary'
              href={viewExampleScenario}
            >
              View Live Example
            </Link>
          )}
          {demoGithubRepo && (
            <Link
              className={clsx(classes.button, classes.button__github)}
              asPageButton
              type='secondary'
              href={exploreExampleScenario}
            >
              <TbBrandGithub className={classes.icon} />
              Explore Example App
            </Link>
          )}
          <Link
            className={classes.button}
            asPageButton
            type='primary'
            href={addScenario}
          >
            Add to your app
          </Link>
        </div>
      </hgroup>
    </>
  )
}
